export const fetchCourseParticipants = async (setCourseParticipants, setStatusMessage, course_ID) => {
  if (course_ID !== 0) {
    try {
      setCourseParticipants([])
      const response = await fetch(
        "https://wad-backend.ws381566.remote.ac/getCourseParticipants.php?adminRequired=true&course_ID=" + course_ID,
        {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );
  
      const result = await response.json();
  
      if (result.status === "authenticationError") {
        window.location.href = "/login";
        return;
      }
  
      if (result.status === "success") {
        setCourseParticipants(result.enrolled_users);
      } else {
        setStatusMessage(result.message || "Failed to execute query");
      }
    } catch (error) {
      setStatusMessage(error.message);
    }     
  } else{return null}
};